"use strict";

const attachBurgerListener = () => {
  const els = document.getElementsByClassName("rpc3-burger");
  for (const el of els) {
    el.addEventListener("click", () => {
      document.body.classList.toggle("rpc3-head-open");
    });
  }
};

export default attachBurgerListener;
